import React, { PureComponent } from 'react';
import Slider from 'react-animated-slider';

const banners = [
	{
        title: 'TORRES E ESTRUTURAS METÁLICAS PARA TELECOM',
        subtitle: 'Temos tudo para você montar sua torre metálica ',
		button: {
            text: 'Confira nossos produtos',
            cls: 'btn-blue',
        },
		class: 'box-text-right',
	},
	{
        title: 'TORRES PARA TELECOMUNICAÇÕES',
        subtitle: 'Soluções em Telecom',
		button: {
            text: 'Confira nossos produtos',
            cls: 'btn-blue',
        },
		class: 'box-text-right',
	},	
	{
        title: 'TORRES E ESTRUTURAS METÁLICAS TELECOM',
        subtitle: 'Temos tudo para você montar sua torre metálica ',
		button: {
            text: 'Confira nossos produtos',
            cls: 'btn-blue',
        },
		class: 'box-text-right',
	},
];

class SliderLetters extends PureComponent {
    render() {
        return (        
            <Slider autoplay={5000} infinite={true}>
                {banners.map((slider, index) => 
                    <div key={index} 
                        className="animated fadeIn"
                    >
                        <div className="container">
                            <div className={`box-text animated fadeIn ${slider.class}`}>
                                <div className="bg">
                                    <h2 >{slider.title}</h2>
                                    { slider.subtitle && <p>{slider.subtitle}</p> }
                                    { slider.button && <button className={`btn ${slider.button.cls}`}>{slider.button.text}</button> }        
                                </div>                     
                            </div>
                        </div>
                    </div>
                )}
            </Slider>           
        )
    }
}
export default SliderLetters